import { render, staticRenderFns } from "./FormReferenceBankV2.vue?vue&type=template&id=511e0020"
import script from "./FormReferenceBankV2.vue?vue&type=script&lang=js"
export * from "./FormReferenceBankV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports